export default{
    form:[],
    ventas:[],
    isOk: false,
    error:null,
    errorMessage:'',
    folio:'',
    oslp:[]

}